import { BrowserViewportFactory } from 'pf-frontend-common/src/module/browser/viewport.factory';

import { MintagaReviewView } from 'common/module/building-review/mintaga-review/view';
import { StatsGtmProviderService } from 'common/service/stats-gtm-provider/service';

export function MintagaReviewViewFactory(): MintagaReviewView {
  return new MintagaReviewView(StatsGtmProviderService(), BrowserViewportFactory());
}
